
(() => {
  const CART_DRAWER_SECTION = 'cart-drawer';
  const CART_ICON_SECTION   = 'cart-icon-bubble';

  /* ── helpers ── */
  const postJSON = async (url, data) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`cart API ${res.status}`);
    return res.json();
  };

  const fetchSections = async () => {
    const url = `${window.location.origin}/?sections=${encodeURIComponent(
      [CART_DRAWER_SECTION, CART_ICON_SECTION].join(',')
    )}`;
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`sections fetch ${res.status}`);
    return res.json();
  };

  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* ── surgical cart drawer refresh ──
     We NEVER replaceWith() the <cart-drawer> element because that destroys
     the Web Component and kills all event listeners / scroll locks.
     Instead we patch only the inner regions that change:
       • .js-contents          (cart items list + line prices)
       • .cart-drawer__footer  (subtotal + checkout button)
       • .cart-drawer__header  (keeps "Cart • N items" heading in sync)
  ── */
  const patchDrawer = (freshHTML) => {
    const fresh    = parse(freshHTML);
    const liveRoot = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer');
    if (!liveRoot) return;

    const regions = ['.js-contents', '.cart-drawer__footer', '.cart-drawer__header'];
    regions.forEach((sel) => {
      const freshEl = fresh.querySelector(sel);
      const liveEl  = liveRoot.querySelector(sel);
      if (freshEl && liveEl) liveEl.innerHTML = freshEl.innerHTML;
    });

    // Sync is-empty state so drawer shows correct empty/full view
    const freshDrawer = fresh.querySelector('cart-drawer') || fresh.querySelector('#CartDrawer');
    if (freshDrawer) {
      liveRoot.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
    }
  };

  const patchIcon = (freshHTML) => {
    const fresh   = parse(freshHTML);
    const newIcon = fresh.querySelector('#cart-icon-bubble, cart-icon-bubble');
    const curIcon = document.querySelector('#cart-icon-bubble, cart-icon-bubble');
    if (newIcon && curIcon) curIcon.innerHTML = newIcon.innerHTML;
  };

  const refreshCartUI = async () => {
    const sections = await fetchSections();
    if (sections[CART_DRAWER_SECTION]) patchDrawer(sections[CART_DRAWER_SECTION]);
    if (sections[CART_ICON_SECTION])   patchIcon(sections[CART_ICON_SECTION]);
    document.dispatchEvent(new CustomEvent('cart:updated'));
  };

  /* ── remove button handler ── */
  document.addEventListener('click', async (e) => {
    const t = e.target;
    if (!t?.closest) return;

    const removeBtn = t.closest('cart-remove-button button, cart-remove-button a, cart-remove-button');
    if (!removeBtn) return;

    const host = t.closest('cart-remove-button');
    const line = parseInt(
      host?.dataset?.index || host?.getAttribute('data-index') ||
      t.closest('[data-index]')?.dataset?.index || 0,
      10
    );
    if (!line || line < 1) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const btnEl = removeBtn.tagName?.toLowerCase() === 'button'
      ? removeBtn
      : (removeBtn.querySelector('button') || removeBtn);

    try {
      btnEl.setAttribute('aria-busy', 'true');
      btnEl.style.pointerEvents = 'none';
      await postJSON('/cart/change.js', { line, quantity: 0 });
      await refreshCartUI();
    } catch (err) {
      console.error('[OVRA cart fix] remove failed', err);
      window.location.reload();
    } finally {
      try { btnEl.removeAttribute('aria-busy'); btnEl.style.pointerEvents = ''; } catch (_) {}
    }
  }, true);

  /* ── quantity input change handler ── */
  document.addEventListener('change', async (e) => {
    const input = e.target;
    if (!input?.matches) return;
    if (!input.matches('input[name="updates[]"], input[name^="updates"], input[data-quantity-input]')) return;

    const cartItem = input.closest('[data-index].cart-item, .cart-item[data-index], [data-index][id^="CartDrawer-Item"]');
    const line = parseInt(cartItem?.dataset?.index, 10);
    const qty  = parseInt(input.value, 10);

    if (!line || line < 1 || Number.isNaN(qty) || qty < 0) return;

    // Block the native theme handler — it only patches items, not the subtotal footer
    e.stopImmediatePropagation();

    try {
      await postJSON('/cart/change.js', { line, quantity: qty });
      await refreshCartUI();
    } catch (err) {
      console.error('[OVRA cart fix] qty change failed', err);
    }
  }, true);

  /* ── +/- button click handler ──
     The theme's QuantityInput Web Component updates the input value synchronously
     inside its own click handler. We wait a tick then debounce the API call so
     rapid clicks only trigger one request.
  ── */
  let qtyDebounce = null;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('button.quantity__button');
    if (!btn) return;

    const cartItem = btn.closest('[data-index].cart-item, .cart-item[data-index], [data-index][id^="CartDrawer-Item"]');
    if (!cartItem) return;

    const inputEl = cartItem.querySelector('input[name="updates[]"], input[name^="updates"], input[data-quantity-input]');
    if (!inputEl) return;

    setTimeout(() => {
      const line = parseInt(cartItem.dataset?.index, 10);
      const qty  = parseInt(inputEl.value, 10);
      if (!line || line < 1 || Number.isNaN(qty) || qty < 0) return;

      clearTimeout(qtyDebounce);
      qtyDebounce = setTimeout(async () => {
        try {
          await postJSON('/cart/change.js', { line, quantity: qty });
          await refreshCartUI();
        } catch (err) {
          console.error('[OVRA cart fix] qty +/- failed', err);
        }
      }, 100);
    }, 50);
  }, true);

})();
